import { render, staticRenderFns } from "./RegionGroupItem.vue?vue&type=template&id=3f1af9c6&scoped=true"
import script from "./RegionGroupItem.vue?vue&type=script&lang=js"
export * from "./RegionGroupItem.vue?vue&type=script&lang=js"
import style0 from "./RegionGroupItem.vue?vue&type=style&index=0&id=3f1af9c6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f1af9c6",
  null
  
)

export default component.exports